<template lang="pug">
    game-preview-settings(v-if="settings")
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_game') }}
            span(slot="value") {{ $i18n.t('common.common_gameName_equation') }}
        game-preview-setting(v-if="settings.amountOfExamples")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}
            span(slot="value") {{ settings.amountOfExamples }}
        game-preview-setting(v-if="settings.timeLimit")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_timeLimit') }}
            span(slot="value") {{ timeLimit }}
        game-preview-setting(v-if="settings.timeForAnswer != '-1'")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_timeToAnswer') }}
            span(slot="value")
                | {{ settings.timeForAnswer }} {{ $i18n.t('trainer.trainer_gameFormSettingValue_seconds') }}
        game-preview-setting(v-if="parameters.changingMultipliers")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_changingMultipliers') }}
            span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_on') }}
        game-preview-setting(v-if="settings.numbers.length !== 0")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_numbers') }}
            span(slot="value") {{ settings.numbers.join(', ') }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_operations') }}
            span(slot="value") {{ field('operations') }}
        game-preview-setting(v-if="settings.dictation")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_dictation') }}
            span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_on') }}
</template>

<script>
    import preview from '../../../utils/multiplication-and-division/preview';
    import GamePreviewSettings from './GamePreviewSettings.vue';
    import GamePreviewSetting from './GamePreviewSetting.vue';

    export default {
        props: ['parameters', 'exerciseId', 'type'],
        mixins: [preview],
        components: {
            GamePreviewSettings,
            GamePreviewSetting,
        },
        computed: {
            answers() {
                if (this.parameters.positiveAnswers && this.parameters.negativeAnswers) {
                    return this.$i18n.t('trainer.trainer_gameFormSetting_answersAny');
                }
                if (this.parameters.positiveAnswers) {
                    return this.$i18n.t('trainer.trainer_gameFormSetting_answersOnlyPositive');
                }
                if (this.parameters.negativeAnswers) {
                    return this.$i18n.t('trainer.trainer_gameFormSetting_answersOnlyNegative');
                }
                return '';
            },
            timeLimit() {
                return (
                    this.parameters.timeLimit +
                    ' ' +
                    this.$i18n.tc('trainer.trainer_gamePreview_timeParamMinuteDeclination', this.parameters.timeLimit)
                );
            },
        },
    };
</script>
